import {Component, Inject, Injector, OnInit} from '@angular/core';
import {format} from 'date-fns';
import {es} from 'date-fns/locale';
import {ApiStatusEnum} from '../../Shared/Enum/api-status.enum';
import {ApiResponse} from '../../Services/Api/base-api.service';
import {WidgetControllerComponent} from './widget-controller-component';
import {WidgetComponent} from '../../Models/Widgets/widget.interface';

@Component({
  selector: 'app-widget-data-controller',
  template: '',
  standalone: false
})
export abstract class WidgetDataControllerComponent<T> extends WidgetControllerComponent implements OnInit, WidgetComponent {

  data!: T;
  fakeData!: T;

  loadedData: boolean = false;

  get date(): string {
    return this.widgetsManager.filters?.fecha_inicio
      ? format(this.widgetsManager.filters.fecha_inicio, 'MMM yy', {locale: es})
      : 'Mes actual';
  }

  get local(): string {
    return this.widgetsManager.filters?.local?.nombre || '';
  }

  protected constructor(
    protected override injector: Injector,
    @Inject(String) protected apiService: any,
  ) {
    super(injector);
  }

  ngOnInit() {

    if (this.isStoreView) {
      return;
    }

    this.getListData();
  }


  /**
   * Obtener datos del servidor
   *
   */
  getListData() {

    this.getData().then((response: ApiResponse) => {

      if (response.status === 1 || response.status === ApiStatusEnum.success) {
        this.setData(response.data);
      }

    }).finally(() => {
      this.loadedData = true;
    });
  }


  /**
   * Establecer datos
   *
   */
  setData(data: any) {
    this.data = data;
  }


  /**
   * Obtener datos
   *
   */
  protected abstract getData(): Promise<any>;

}
